"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var react_measure_1 = tslib_1.__importDefault(require("react-measure"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var sdk_model_1 = require("@gooddata/sdk-model");
var KpiValue_1 = tslib_1.__importDefault(require("./KpiValue"));
var KpiPop_1 = tslib_1.__importDefault(require("./KpiPop"));
var filters_1 = require("../utils/filters");
var translations_1 = require("./utils/translations");
var KpiContent = /** @class */ (function (_super) {
    tslib_1.__extends(KpiContent, _super);
    function KpiContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KpiContent.prototype.renderPeriodOverPeriod = function (clientWidth, clientHeight) {
        var _a, _b;
        if (this.props.kpi.kpi.comparisonType === "none") {
            return false;
        }
        var _c = this.props, kpiResult = _c.kpiResult, enableCompactSize = _c.enableCompactSize;
        var isDateFilterNotRelevant = filters_1.isDateFilterIrrelevant(this.props.kpi);
        var isDateFilterAbsolute = this.props.filters.some(sdk_model_1.isAbsoluteDateFilter);
        var isDateFilterAllTime = this.props.filters.every(function (f) { return !sdk_model_1.isDateFilter(f) || sdk_model_1.isAllTimeDateFilter(f); });
        var dateFilter = this.props.filters.find(sdk_model_1.isDateFilter); // for now we use the first date filter available for this
        var popLabel = translations_1.getKpiPopLabel(dateFilter, this.props.kpi.kpi.comparisonType, this.props.intl);
        var popDisabled = isDateFilterAllTime || isDateFilterNotRelevant || isDateFilterAbsolute;
        var isSdkError = sdk_ui_1.isGoodDataSdkError(this.props.error);
        var isNoData = isSdkError && this.props.error.message === sdk_ui_1.ErrorCodes.NO_DATA;
        var comparisonMeaning = sdk_backend_spi_1.isLegacyKpiWithComparison(this.props.kpi.kpi)
            ? this.props.kpi.kpi.comparisonDirection
            : undefined;
        return (react_1.default.createElement(KpiPop_1.default, { disabled: popDisabled, isLoading: this.props.isLoading, currentPeriodValue: (_a = kpiResult === null || kpiResult === void 0 ? void 0 : kpiResult.measureResult) !== null && _a !== void 0 ? _a : null, previousPeriodValue: (_b = kpiResult === null || kpiResult === void 0 ? void 0 : kpiResult.measureForComparisonResult) !== null && _b !== void 0 ? _b : null, previousPeriodName: popLabel, format: kpiResult === null || kpiResult === void 0 ? void 0 : kpiResult.measureFormat, error: !isNoData ? this.props.error : undefined, separators: this.props.separators, meaning: comparisonMeaning, enableCompactSize: enableCompactSize, clientWidth: clientWidth, clientHeight: clientHeight }));
    };
    KpiContent.prototype.renderValue = function (clientHeight) {
        var _a;
        var _b = this.props, kpiResult = _b.kpiResult, isKpiValueClickDisabled = _b.isKpiValueClickDisabled, onKpiValueClick = _b.onKpiValueClick, enableCompactSize = _b.enableCompactSize, kpi = _b.kpi;
        var isSdkError = sdk_ui_1.isGoodDataSdkError(this.props.error);
        var isNoData = isSdkError && this.props.error.message === sdk_ui_1.ErrorCodes.NO_DATA;
        var hasComparison = kpi.kpi.comparisonType !== "none";
        var kpiValue = (react_1.default.createElement(KpiValue_1.default, { isLoading: this.props.isLoading, error: !isNoData ? this.props.error : undefined, errorHelp: this.props.errorHelp, value: (_a = kpiResult === null || kpiResult === void 0 ? void 0 : kpiResult.measureResult) !== null && _a !== void 0 ? _a : null, format: kpiResult === null || kpiResult === void 0 ? void 0 : kpiResult.measureFormat, separators: this.props.separators, disableKpiDrillUnderline: this.props.isKpiUnderlineHiddenWhenClickable, enableCompactSize: enableCompactSize, clientHeight: clientHeight, hasComparison: hasComparison }));
        if (onKpiValueClick) {
            if (isKpiValueClickDisabled) {
                return react_1.default.createElement("span", { className: "kpi-link s-kpi-link-nonclickable" }, kpiValue);
            }
            else {
                return (react_1.default.createElement("a", { className: "kpi-link s-kpi-link-clickable", onClick: this.props.onKpiValueClick }, kpiValue));
            }
        }
        return kpiValue;
    };
    KpiContent.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement("div", { className: "gd-kpi-widget-content" },
            react_1.default.createElement("div", { className: "visualization-content" },
                react_1.default.createElement(react_measure_1.default, { client: true }, function (_a) {
                    var _b, _c, _d;
                    var measureRef = _a.measureRef, contentRect = _a.contentRect;
                    return (react_1.default.createElement("div", { className: "gd-visualization-content", ref: measureRef },
                        react_1.default.createElement("div", { className: "headline" },
                            _this.renderValue((_b = contentRect.client) === null || _b === void 0 ? void 0 : _b.height),
                            _this.renderPeriodOverPeriod((_c = contentRect.client) === null || _c === void 0 ? void 0 : _c.width, (_d = contentRect.client) === null || _d === void 0 ? void 0 : _d.height))));
                }))));
    };
    KpiContent.defaultProps = {
        isKpiValueClickDisabled: false,
        filters: [],
        isKpiUnderlineHiddenWhenClickable: false,
    };
    return KpiContent;
}(react_1.Component));
exports.default = react_intl_1.injectIntl(KpiContent);
//# sourceMappingURL=KpiContent.js.map